export function DocumentViewerSkeleton() {
  return (
    <div className="flex flex-col h-full w-full animate-pulse">

      {/* Toolbar skeleton */}
      <div className="flex items-center gap-3 border-b border-border px-3 py-2">
        <div className="h-6 w-6 rounded bg-muted" />
        <div className="h-6 w-6 rounded bg-muted" />
        <div className="h-6 w-6 rounded bg-muted" />
        <div className="flex-grow" />
        <div className="h-6 w-14 rounded bg-muted" />
        <div className="flex-grow" />
        <div className="h-6 w-6 rounded bg-muted" />
      </div>

      {/* Body skeleton */}
      <div className="grid grid-cols-[180px,1fr] h-full">

        {/* Thumbnails */}
        <div className="border-r border-border overflow-y-auto p-3 flex flex-col gap-3">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-40 w-full bg-muted rounded" />
          ))}
        </div>

        {/* Main page */}
        <div className="flex justify-center items-start overflow-auto pt-10">
          <div className="w-[650px] h-[850px] bg-muted rounded" />
        </div>
      </div>
    </div>
  );
}
